import { CaretRight } from '@phosphor-icons/react';
import type { ReactNode } from 'react';

export interface LinkingOptionButtonProps {
	text: string | React.ReactNode;
	action: () => void;
	/** Icono de la acción — es lo que hace la fila escaneable sin leerla
	 * completa; tres párrafos idénticos en gris obligan a leer los tres. */
	icon?: ReactNode;
}

/** Fila de acción de las superficies de ayuda de vinculación. Es un <button> y
 * no un <div> clickeable: el teclado y los lectores de pantalla lo necesitan. */
const LinkingOptionButton = ({
	text,
	action,
	icon,
}: LinkingOptionButtonProps) => (
	<button
		type='button'
		onClick={action}
		className='border-h-neutral-95 flex w-full items-center gap-3 rounded-xl border bg-white p-3 text-left shadow-sm'>
		{icon && (
			<span className='bg-h-primary-95 text-h-primary-50 flex h-10 w-10 shrink-0 items-center justify-center rounded-lg'>
				{icon}
			</span>
		)}
		{typeof text === 'string' ? (
			<p
				className='text-h-text-heading min-w-0 flex-1 text-sm leading-snug font-light'
				dangerouslySetInnerHTML={{ __html: text }}
			/>
		) : (
			<span className='min-w-0 flex-1'>{text}</span>
		)}
		<CaretRight className='text-h-primary-50 min-w-4 shrink-0' weight='bold' />
	</button>
);

export default LinkingOptionButton;
